import { useCallback } from 'react'
import { useDispatch, useSelector } from '../'
import { setGuideQueue } from './index'
import type { GuideKeys, UserInitState } from './types'

/**
 * 使用某几个引导标识
 * @param keys
 * @returns
 */
export const useGuides = (keys: GuideKeys[]) => {
  const guideQueue = useSelector((state) => state.user.guideQueue)
  return guideQueue.filter((item) => keys.includes(item.key)) as UserInitState['guideQueue']
}

/**
 * 按顺序返回第一个未展示过的guide，如果全部展示过，返回null
 * @param keys
 */
export const useGuideQueue = (keys: GuideKeys[]) => {
  const dispatch = useDispatch()
  const guideQueue = useGuides(keys)
  const firstUnshowed = guideQueue.find((i) => !i.showed)
  const firstUnshowedKey = firstUnshowed ? firstUnshowed.key : null

  const setShowed = useCallback((key: GuideKeys) => dispatch(setGuideQueue({ key })), [dispatch])
  const next = useCallback(() => {
    if (!firstUnshowedKey) return
    setShowed(firstUnshowedKey)
  }, [setShowed, firstUnshowedKey])
  return {
    /** 第一个未展示过的guide，如果全部展示过，返回null */
    firstUnshowedKey,
    /** 展示下一个guide */
    next,
    guideQueue,
    /** 设置某个key为已展示 */
    setShowed,
  }
}
